import React, { Component } from "react";
import MapsListComponent from "../components/MapsListComponent";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../Actions/Dashboard";

class MapsListContainer extends Component {
  render() {
    return <MapsListComponent content={this.props.content}/>;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(MapsListContainer);